<template>
  <form @submit.prevent="save">
    <v-container fluid>
      <v-card-text
        v-if="!($page.props.status == 'passwords.sent')"
      >
        Haben Sie Ihr Passwort vergessen? Kein Problem. Teilen Sie uns einfach Ihre E-Mail-Adresse mit und wir senden Ihnen per E-Mail einen Link zum Zurücksetzen des Passworts, über den Sie ein Neues auswählen können.
      </v-card-text>
      <v-card-text>
        <span v-if="$page.props.status == 'passwords.sent'">Wir haben Ihnen den Link zum Zurücksetzen Ihres Passworts per E-Mail zugeschickt!</span>
        <v-text-field
          v-else
          v-model="form.email"
          label="Email"
          append-icon="mdi-email"
          outlined
          class="form-control"
          type="email"
          name="email"
          :class="{ 'is-invalid': form.errors.email }"
          :error="form.errors.email"
          :error-messages="form.errors.email"
        />
      </v-card-text>
      <v-card-actions>
        <inertia-link class="v-btn v-btn--flat v-btn--text theme--light v-size--small primary--text" :href="route('login')" method="get">
          Zurück zum Login
        </inertia-link>
        <v-spacer />
        <v-btn
          v-if="!($page.props.status == 'passwords.sent')"
          depressed
          :loading="loading"
          color="primary"
          type="submit"
        >
          Neues Passwort
        </v-btn>
      </v-card-actions>
    </v-container>
  </form>
</template>

<script>
import Layout from '@/Layouts/Basic'

export default {
   metaInfo: { title: 'Passwort vergessen' },
   components: {
      //
   },
   layout: (h, page) => h(Layout, [page]),
   data () {
      return {
         loading: false,
         showPassword: false,
         form: this.$inertia.form({
            email: null,
            password: null,
            remember: null,
         }),
      }
   },
   methods: {
      save () {
         this.loading = true
         this.$inertia.post(this.route('password.email'), this.form).then(() => this.loading = false)
      },
   },
}
</script>
